// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"generic-wrapper__wrapper___3Q0W4","wrapper__body":"generic-wrapper__wrapper__body___3ZQWq","wrapperBody":"generic-wrapper__wrapper__body___3ZQWq"};
    if(module.hot) {
      // 1567920248474
      var cssReload = require("C:/Users/kpereira/WebstormProjects/clones/destiny-chalice-sim/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  